// i18nOwl-ignore [app-twitter.triggerIntegrations.follow.title]
import type {TriggerIntegration} from '@cohort/merchants/apps';
import TwitterFollowTriggerIntegrationConfigComponent from '@cohort/merchants/apps/twitter/triggerIntegrations/follow/ConfigComponent';
import TwitterFollowTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/twitter/triggerIntegrations/follow/StepCompletionTitleComponent';
import type {TwitterFollowTriggerStruct} from '@cohort/shared/schema/apps/twitter/triggers/follow';
import {TwitterFollowTriggerIntegrationSpec} from '@cohort/shared/schema/apps/twitter/triggers/follow';

export const TwitterFollowTriggerIntegration: TriggerIntegration<TwitterFollowTriggerStruct> = {
  spec: TwitterFollowTriggerIntegrationSpec,
  configComponent: TwitterFollowTriggerIntegrationConfigComponent,
  stepCompletionTitleComponent: TwitterFollowTriggerIntegrationStepCompletionTitleComponent,
};
